<template>
    <div style="max-width: 770px;">
        <Steps steps="3" current="2" />
        <form @submit.prevent="validateBeforeSubmit" class="pb-5">

           <h3 class="uc">Welcome Back!</h3>
            <p class="light mb-4">It looks like we have your information on file, please enter the last four digits of your <abbr title="Social Security Number">SSN</abbr> to confirm and we'll quickly pull up your details for a super fast loan submission!</p>

            <div class="row">
                <div class="col-lg-6 col-xl-4">
                    <CleaveInput
                        label="Last 4 digits of your SSN"
                        id="ssnLast4"
                        name="ssnLast4"
                        type="tel"
                        maxlength="4"
                        autocomplete="off"
                        v-model="ssnLast4"
                        v-validate="{ required: true, regex: /^([0-9]{4})$/ }"
                 
                        :exval="validationAttempt"
                        :cleaveoptions="masks.ssnLast4"

                        extracss="dont-mark"
                 
                        errormsg="This is a required field"
                        :error="errors.first('ssnLast4')"
                    />
                </div>
            </div>

            <div v-if="errorMessage" class="alert alert-danger">
                Unfortunately that number doesn't match the records in our system. Try again or <router-link to="/registration/2">Click Here to submit a new application</router-link>.
            </div>
            
            <div class="my-5 d-flex align-items-center">
                <button class="btn btn-cta btn-red uc" id="form-submit">{{ this.loading ? 'Sending...' : 'Continue' }}</button>
                <div>
                    <transition name="slide">
                        <span class="some-errors" v-if="(errors.items.length != 0 && validationAttempt)">You have some errors</span>
                    </transition>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import CleaveInput from '@/components/form/CleaveInput.vue';
import Steps from '@/components/form/Steps.vue';

import axios from 'axios';
import { mapGetters, mapActions } from "vuex";



export default {
    name: 'FormRecognise',
    title: 'Retrieve Your Account',
    components:{
        CleaveInput,
        Steps
    },
    data() {
	  return {
            ssnLast4: '',
            validationAttempt: false,
            loading: false,
            errorMessage: false,
            masks: {
				ssnLast4: { numericOnly: true, blocks: [4] },
            },
		}
    },
    computed: mapGetters(["formData"]),
    methods: {
        ...mapActions(['authoriseUser']),
        validateBeforeSubmit(){
            this.validationAttempt = true;
			this.$validator.validate().then((result) => {
        		if (result) {
					this.sendData();	
          		    return;
				} else {

                }
      		});
		},
		async sendData(){
			const endpoint = `${process.env.VUE_APP_LOCAL_API}verifyEmail?email=${this.formData.email}&ssn_last4=${this.ssnLast4}`;
			try {
				this.loading = true;
				const response = await axios.get(endpoint);
				if(response.data.body){
                    this.authoriseUser({
                        clientKey: response.data.clientKey,
                        ...response.data.body
                    });
                    this.$router.push({ path: 'returning' });
				} else {
                    this.loading = false;
                    this.errorMessage = true;
                }
			} catch(err) {
				this.loading = false;
				console.log(err);
			}
		}
    }
}
</script>